import { useContext } from 'react';

import { ContactModalStateContext } from '../contexts';

const useContactModalState = () => useContext(ContactModalStateContext);

export default useContactModalState;
